export default "__VITE_ASSET__DaJ1lrAe__"